module.exports = __webpack_public_path__ + "static/img/launcher.be30db2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/launcher.png
// module id = 59
// module chunks = 0